export default __webpack_public_path__ + "static/media/DSS_HeroBanner_675x300_Tapes-and-Adhesives_Final.c917f129.gif";